module.exports = __webpack_public_path__ + "987dbc064d59bd493611b6a86632c75f.png";